import firebase from 'firebase/app'
import 'firebase/firestore';

export default {
  fetchPaginaEstacionamento({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection('estabelecimentos')
        .doc(data.estabelecimentoId)
        .collection('paginas')
        .where("tipo", "==", data.tipoPagina)
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            const estacionamento = {}
            snapshot.forEach(doc => {
              estacionamento.tipoPagina = doc.data().tipo
              estacionamento.titulo = doc.data().titulo
              estacionamento.descricao = doc.data().descricao
              estacionamento.horarioFuncionamento = doc.data().horarioFuncionamento
              estacionamento.valores = doc.data().valores
            });
            commit('SET_PAGINA_ESTACIONAMENTO', estacionamento)
            resolve(snapshot)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchPaginaFilaEspera({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection('estabelecimentos')
        .doc(data.estabelecimentoId)
        .collection('paginas')
        .where("tipo", "==", data.tipoPagina)
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            const filaEspera = {}
            snapshot.forEach(doc => {
              filaEspera.tipoPagina = doc.data().tipo
              filaEspera.imagem = doc.data().imagem
              filaEspera.titulo = doc.data().titulo
              filaEspera.descricao = doc.data().descricao
              filaEspera.tempoMedioEspera = doc.data().tempoMedioEspera
            });
            commit('SET_PAGINA_FILAESPERA', filaEspera)
            resolve(snapshot)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchPaginaAreaPet({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection('estabelecimentos')
        .doc(data.estabelecimentoId)
        .collection('paginas')
        .where("tipo", "==", data.tipoPagina)
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            const areaPet = {}
            snapshot.forEach(doc => {
              areaPet.tipoPagina = doc.data().tipo
              areaPet.imagem = doc.data().imagem
              areaPet.titulo = doc.data().titulo
              areaPet.descricao = doc.data().descricao
            });
            commit('SET_PAGINA_AREAPET', areaPet)
            resolve(snapshot)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchPaginaFormasPagamento({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection('estabelecimentos')
        .doc(data.estabelecimentoId)
        .collection('paginas')
        .where("tipo", "==", data.tipoPagina)
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            const formasPag = {}
            snapshot.forEach(doc => {
              formasPag.tipoPagina = doc.data().tipo
              formasPag.imagem = doc.data().imagem
              formasPag.titulo = doc.data().titulo
              formasPag.descricao = doc.data().descricao
              formasPag.cartoesCredito = doc.data().cartoesCredito
              formasPag.cartoesDebito = doc.data().cartoesDebito
              formasPag.cartoesRefeicao = doc.data().cartoesRefeicao
            });
            commit('SET_PAGINA_FORMASPAG', formasPag)
            resolve(snapshot)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchPaginaHappyPromocoes({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection('estabelecimentos')
        .doc(data.estabelecimentoId)
        .collection('paginas')
        .where("tipo", "==", data.tipoPagina)
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            const happyPromo = {}
            snapshot.forEach(doc => {
              happyPromo.tipoPagina = doc.data().tipo
              happyPromo.imagem = doc.data().imagem
              happyPromo.titulo = doc.data().titulo
              happyPromo.descricao = doc.data().descricao
            });
            commit('SET_PAGINA_HAPPYPROMO', happyPromo)
            resolve(snapshot)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}